import { SortField } from "../types";

export const RECIPE_LIST_COLUMN_COUNT = 11;

export const getRecipeListColumnCount = () => RECIPE_LIST_COLUMN_COUNT;

export const recipeListTableTextWrapClass =
  "tw-max-w-0 tw-whitespace-normal tw-break-words tw-align-top tw-overflow-hidden";

export const recipeListTableColumnClass = {
  expand: "tw-w-[3%] tw-max-w-[1.5rem] tw-min-w-[1rem] tw-px-2.5",
  recipeName: `tw-w-[14%] tw-min-w-[6rem] ${recipeListTableTextWrapClass}`,
  variation: `tw-w-[9%] tw-min-w-[4.5rem] ${recipeListTableTextWrapClass}`,
  numeric: "tw-w-[7%] tw-min-w-[4rem] tw-text-center tw-whitespace-nowrap",
  impactChange: "tw-w-[8%] tw-min-w-[4.5rem] tw-text-center tw-whitespace-nowrap",
  recipeType: "tw-w-[8%] tw-min-w-[5rem] tw-max-w-0 tw-text-center tw-align-top tw-overflow-hidden",
  createdBy:
    "tw-w-[7%] tw-min-w-[5rem] tw-max-w-[6rem] tw-text-left tw-whitespace-nowrap tw-overflow-hidden tw-align-middle",
  date: `tw-w-[7%] tw-min-w-[4.5rem] tw-text-center ${recipeListTableTextWrapClass}`,
  actions:
    "tw-w-[14%] tw-min-w-[11rem] tw-max-w-[14%] tw-shrink-0 tw-px-2 tw-text-left tw-whitespace-nowrap tw-align-middle"
} as const;

export const recipeListTableHeaderColumnClass = {
  expand: recipeListTableColumnClass.expand,
  recipeName: "tw-w-[14%] tw-min-w-[6rem] tw-text-left tw-align-middle",
  variation: "tw-w-[9%] tw-min-w-[4.5rem] tw-text-left tw-align-middle",
  numeric: "tw-w-[7%] tw-min-w-[4rem] tw-text-center tw-align-middle",
  impactChange: "tw-w-[8%] tw-min-w-[4.5rem] tw-text-center tw-align-middle",
  recipeType: "tw-w-[8%] tw-min-w-[5rem] tw-text-center tw-align-middle",
  createdBy: "tw-w-[7%] tw-min-w-[5rem] tw-max-w-[6rem] tw-text-left tw-align-middle",
  date: "tw-w-[7%] tw-min-w-[4.5rem] tw-text-center tw-align-middle",
  actions:
    "tw-w-[14%] tw-min-w-[11rem] tw-max-w-[14%] tw-shrink-0 tw-px-2 tw-text-center tw-align-middle"
} as const;

export type RecipeListTableColumnAlign = "left" | "center";

export interface RecipeListSortColumnConfig {
  label: string;
  field: SortField;
  headerClass: string;
  align: RecipeListTableColumnAlign;
}

export const RECIPE_LIST_SORT_COLUMNS: RecipeListSortColumnConfig[] = [
  {
    label: "Recipe Name",
    field: "recipeName",
    headerClass: recipeListTableHeaderColumnClass.recipeName,
    align: "left"
  },
  {
    label: "Variation",
    field: "variationName",
    headerClass: recipeListTableHeaderColumnClass.variation,
    align: "left"
  },
  {
    label: "Baseline (kgCO₂eq/kg)",
    field: "baselineImpact",
    headerClass: recipeListTableHeaderColumnClass.numeric,
    align: "center"
  },
  {
    label: "Variation (kgCO₂eq/kg)",
    field: "variationImpact",
    headerClass: recipeListTableHeaderColumnClass.numeric,
    align: "center"
  },
  {
    label: "Impact Change %",
    field: "impactChange",
    headerClass: recipeListTableHeaderColumnClass.impactChange,
    align: "center"
  },
  {
    label: "Recipe Type",
    field: "recipeTypeClassification",
    headerClass: recipeListTableHeaderColumnClass.recipeType,
    align: "center"
  },
  {
    label: "Updated",
    field: "updatedDate",
    headerClass: recipeListTableHeaderColumnClass.date,
    align: "center"
  },
  {
    label: "Calculated",
    field: "calculatedDate",
    headerClass: recipeListTableHeaderColumnClass.date,
    align: "center"
  },
  {
    label: "Created By",
    field: "createdByName",
    headerClass: recipeListTableHeaderColumnClass.createdBy,
    align: "left"
  }
];
